import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { WalletService } from '@service/wallet.service';
import { AlertService } from '@service/alert.service';
import { AuthService } from '@service/auth.service';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-offer-rewards',
  templateUrl: './offer-rewards.component.html',
  styles: [
  ]
})
export class OfferRewardsComponent implements OnInit {

  isLoggedIn: boolean = false;
  totalReward: number  = 0
  currentReward: any;
  currentUser: any;
  vpa = new FormControl('', Validators.compose([
    Validators.required,
    Validators.pattern(new RegExp('[a-zA-Z0-9\.\-]{2,256}\@[a-zA-Z][a-zA-Z]{2,64}'))
  ]));
  name = new FormControl('', Validators.required);
  isLoading: boolean = false

  constructor(
    private authService: AuthService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<OfferRewardsComponent>,
    private router: Router,
    private benefitsService: WalletService,
    private alertService: AlertService
  ) { }

  ngOnInit(): void {
    this.authService.isLoggedIn.subscribe((res)=> this.isLoggedIn = res)
    this.data.availableRewards.forEach((x)=>  this.totalReward = x.amount + this.totalReward)
    this.currentReward = this.data.currentRewards
    if(this.isLoggedIn){
      this.authService.userProfile.subscribe((res)=>{
        this.currentUser = res || {};
        if (this.currentUser?.name) {
          this.name.patchValue(this.currentUser.name)
        }
        if (this.currentUser.razorpay?.fundAccountVPA) {
          this.vpa.patchValue(this.currentUser.razorpay.fundAccountVPA)
        }
      })
      if(!this.data.availableRewards.length){
        this.isLoading = true
        this.checkPendingRewards()
      }
    }
  }

  closeDialog(){
    this.dialogRef.close()
  }

  checkPendingRewards(){
    this.authService.checkUserOffers().pipe(finalize(()=> this.isLoading = false)).subscribe((offers)=>{
      offers.data.forEach(x => {
        if(x.activity === 'admin_offers_riskProfiling' && !this.currentUser.rewardBenefits.benefitsReceived.adminOfferRiskProfiling){
          this.data.availableRewards.push(x)
        }
        if(x.activity === 'admin_offers_paid_subscription' && !this.currentUser.rewardBenefits.benefitsReceived.adminOfferPaidSubscription){
          this.data.availableRewards.push(x)
        }
      });
      if(this.data.availableRewards.length){
        this.totalReward = this.data.availableRewards.reduce((x, b)=> x + b.amount, 0)
      }
    })
  }

  goTo(page){
    this.closeDialog()
    if(page === 'rewards'){
      this.router.navigate(['/my-rewards'])
    }else if(page === 'next'){
      if(!this.currentUser.rewardBenefits.benefitsReceived.adminOfferRiskProfiling){
        this.router.navigate(['/profile-completion'])
      } else {
        this.router.navigate(['/investment/investpack'])
      } 
    }
  }

  upiDetail() {
    const data = {
      name: this.name.value.replace(/\s+/g, ' ').trim(),
      vpa: this.vpa.value.trim()
    }
    this.benefitsService.rewardToBank(data).subscribe(
      (res) => {
        this.authService.UpdateUserData(false);
        this.currentUser.isEditVpa = false;
      },
      (err: any) => {
        this.currentUser.isEditVpa = false;
      }
    )
  }

  transferPayout(id) {
    let data = {
      rewardId : id
    }
    this.benefitsService.transferPayout(data).subscribe(
      (res) => {
        this.alertService.success(res.message);
      }
    )
  }

  claimReward(id){
    this.closeDialog()
    this.upiDetail()
    this.transferPayout(id)
  }

}
